/**
 * Space between items. Fixed because the offset and index math in `./utils`
 * assumes it; this must match the `gap` applied to the scroll content.
 */
export const ITEM_GAP = 8 // tokens.space.sm
